(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return;
    var targetId = window.location.hash ? window.location.hash.slice(1) : '';
    var successEls = document.querySelectorAll('.contact-form__success[hidden]');
    successEls.forEach(function (el) {
      if (targetId && el.dataset.formId !== targetId) return;
      el.hidden = false;
      var form = el.closest('form');
      if (form) {
        form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea').forEach(function (input) {
          input.value = '';
        });
      }
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
